import { createContext, useContext, useState, useEffect, useMemo } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "hana_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }, [items]);

  const addItem = (item) => setItems((prev) => [...prev, { ...item, lineId: crypto.randomUUID() }]);
  const removeItem = (lineId) => setItems((prev) => prev.filter((i) => i.lineId !== lineId));
  const updateQty = (lineId, qty) => setItems((prev) => prev.map((i) => i.lineId === lineId ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const { count, subtotal } = useMemo(() => {
    let count = 0, subtotal = 0;
    for (const it of items) {
      count += it.quantity;
      const addonsTotal = (it.addons || []).reduce((s, a) => s + a.price, 0);
      subtotal += (it.price + addonsTotal) * it.quantity;
    }
    return { count, subtotal: Math.round(subtotal * 100) / 100 };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
